import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteInstitute, instituteQueryKeys } from '../api/institutes.api';

export function useDeleteInstitute() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteInstitute(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteQueryKeys.all() });
      toast.success('Institute deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete institute');
    },
  });
}
